package uz.ferro.erp.feature.visit.model

import kotlinx.serialization.Serializable

@Serializable
data class GeoAddressDto(
    val id: Long? = null,
    val name: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val county: String? = null
)